const resource = '/api/operation/disbursements'

let service = {
  getAll (filters = {}, page) {
    if (page) {
      filters.page = page
      filters.paginated = true
    }
    return axios.get(resource, { params: filters })
  },
  find (id) {
    return axios.get(resource + '/' + id)
  },
  insert (data) {
    return axios.post(resource, data)
  },
  update (id, data) {
    return axios.put(resource + '/' + id, data)
  },
  remove (id) {
    return axios.delete(resource + '/' + id)
  },
  simulation (data) {
    return axios.post(resource + '/simulation', data)
  },
  aprovationStatus (id) {
    return axios.get(resource + '/' + id + '/aprovation')
  },
  aprove (id) {
    return axios.post(resource + '/' + id + '/aprovation')
  },
  /**
   * Reverte os passos do desembolso excluindo contrato,Carteira, boletos etc.
   *
   * @param id
   * @param {object} data
   * @param data.reason motivo do cancelamento
   * @returns {*|boolean|Promise<boolean>|void|IDBRequest<undefined>}
   */
  revertAprovation (id, data) {
    return axios.delete(resource + '/' + id + '/aprovation', { params: data })
  },
  setType (solicitatonId, data) {
    return axios.post(resource + '/' + solicitatonId + '/type', data)
  },
  generateCarne (id) {
    return axios.post(resource + '/' + id + '/generate_carne')
  },
  generateContract (id) {
    return axios.post(resource + '/' + id + '/generate_contract')
  },
  contractInfo (id) {
    return axios.post(resource + '/' + id + '/contract_info')
  },
  generateBankTransfer (id) {
    return axios.post(resource + '/' + id + '/bank_transfer')
  },
}
export default service


// WEBPACK FOOTER //
// ./resources/assets/js/api/disbursements.js